import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { UserSecurityGroup } from "src/app/features/security-group/interfaces/security-group.interface";
import { Features } from "../enums/features.enum";
import { StorageService } from "../services/storage.service";

export enum SecurityFeature {
  CORPORATION = "corporation",
}

@Injectable({ providedIn: "root" })
export class SecurityFeatureUtility {
  constructor(private storageService: StorageService, private router: Router) {}

  getSecurityFeature(securityFeature: string, validateAccess: boolean = true) {
    const feature = this.storageService
      .getSecurityFeatureData()
      ?.find(
        (c: any) => c.frontendidentifier === securityFeature
      ) as UserSecurityGroup;

    if (validateAccess) {
      this.validateAccess(feature);
    }
    ``;

    return feature;
  }

  getPermissions(
    security: Features,
    validateAccess: boolean = true
  ): { canView: boolean; canManage: boolean } {
    const feature = this.getSecurityFeature(security, validateAccess);
    const canManage = feature?.featureaccess === "M";
    return {
      canView: canManage || feature?.featureaccess === "V",
      canManage,
    };
  }

  getPermissionsForChildFromParent(
    parentSecurity: Features,
    childSecurity: Features,
    validateAccess: boolean = true
  ) {
    const feature = this.getSecurityFeature(parentSecurity, validateAccess);
    const childFeature = this.getSecurityFeature(childSecurity, validateAccess);
    const canManage =
      childFeature?.featureaccess === "M" &&
      (feature?.featureaccess === "M" || feature?.featureaccess === "V");
    return {
      canView:
        canManage ||
        (childFeature?.featureaccess === "V" && feature?.featureaccess === "V"),
      canManage,
    };
  }

  validateAccess(feature: UserSecurityGroup) {
    if (feature?.featureaccess === "N") {
      this.router.navigate(['/', 'access-denied']);
    }
  }

  linkAccessible(feature: string) {
    return this.getSecurityFeature(feature, false)?.featureaccess !== "N";
  }

  canManage(feature: UserSecurityGroup): boolean {
    return feature?.featureaccess === "M";
  }
  canView(feature: UserSecurityGroup): boolean {
    return feature?.featureaccess === "V";
  }
}
